/**
 * Created by Administrator on 2019\1\17 0017.
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalCacheService } from '../../shared/service/global-cache.service';


@Injectable({
  providedIn: 'root'
})
export class HttpUtil {
  constructor(
    private http: HttpClient,
    private globalCacheService: GlobalCacheService
  ) { }

  public formHeaders(): any {
    const merchantId = this.globalCacheService?.merchant ? this.globalCacheService.merchant.id : '';
    const headers = {
      'Content-Type': ' application/x-www-form-urlencoded;charset=utf-8',
      merchantId: '' + merchantId,
      'Cache-Control':  'no-cache, no-store, must-revalidate, post-check=0, pre-check=0',
      'Pragma': 'no-cache',
      'Expires': '0',
    };
    return {
      headers: new HttpHeaders(headers)
    };
  }
  public jsonHeaders(): any {
    const merchantId = this.globalCacheService?.merchant ? this.globalCacheService.merchant.id : '';
    const headers = {
      'Content-Type': 'application/json',
      merchantId: '' + merchantId,
    };
    return { headers: new HttpHeaders(headers) };
  }


  public post(url: string, data?: any, header?: any): any {
    const params = typeof (data) === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data;
    return this.http.post(url, params, header ? header : this.formHeaders());
  }
  public postJson(url: string, data?: any): any {
    return this.http.post(url, data, this.jsonHeaders());
  }
  public put(url: string, data?: any, header?: any): any {
    const params = typeof (data) === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data;
    return this.http.put(url, params, header ? header : this.formHeaders());
  }
  public putJson(url: string, data?: any): any {
    return this.http.put(url, data, this.jsonHeaders());
  }
  public delete(url: string, data?: any): any {
    const params = typeof (data) === 'object' && String(data) !== '[object File]' ? this.paramFormat(data) : data;
    return this.http.delete(url, params);
  }
  public get(url: string, data?: any, header?: any): any {
    return this.http.get(url, { params: data, ...this.formHeaders() });
  }
  // public getJson(url: string, data?: any, header?: any): any {
  //   return this.http.get(url, { params: data, ...this.jsonHeaders() });
  // }





  public request(HttpRequest): any {
    return this.http.request(HttpRequest);
  }


  // 序列化参数
  public paramFormat(data: any): string {
    let paramStr = '';
    let name;
    let value;
    let subName;
    let innerObj;
    // tslint:disable-next-line:forin
    for (name in data) {
      value = data[name];
      if (value instanceof Array) {
        for (const i of value) {
          subName = name;
          innerObj = {};
          innerObj[subName] = i;
          paramStr += this.paramFormat(innerObj) + '&';
        }
      } else if (value instanceof Object) {
        Object.keys(value).forEach((key) => {
          subName = name + '[' + key + ']';
          innerObj = {};
          innerObj[subName] = value[key];
          paramStr += this.paramFormat(innerObj) + '&';
        });
      } else if (value !== undefined && value !== null) {
        paramStr += encodeURIComponent(name) + '='
          + encodeURIComponent(value) + '&';
      }
    }
    return paramStr.length ? paramStr.substr(0, paramStr.length - 1) : paramStr;
  }

}
